export default class StopAreaMapHelper {
  public static moveBreadcrumbs(breadcrumbsElementId: string) {
    const searchBox = document.getElementsByClassName('overlay-component')[0];
    const breadcrumbs = document.getElementById(breadcrumbsElementId);
    if (!breadcrumbs) {
      return;
    }
    searchBox.insertBefore(breadcrumbs, searchBox.firstChild);
    const firstChild = searchBox.firstChild as HTMLElement;
    firstChild.classList.remove('d-none');
  }
}
